import React, {Component} from 'react';
import './linearScaleAnswer.css';

const defaultOptions = {
  minValue: 0, maxValue: 5, minLabel: '', maxLabel: ''
};

export class LinearScaleAnswer extends Component {
  componentWillUnmount() {
    this.props.clearSurvey?.();
  }

  render() {
    const {question, answer, onChange, tabIndex} = this.props;
    const options = {...defaultOptions, ...question.options};
    const values = Array.from(
      {length: Math.max(0, options.maxValue - options.minValue + 1)},
      (_, index) => options.minValue + index
    );

    return <div className="br-survey-scale-answer" role="group"
      aria-label={question.question || 'Choose a number'}>
      <div className="br-survey-scale-answer__choices">
        {values.map(value => <button key={value} type="button"
          className={`br-survey-scale-answer__choice${answer?.answer === value ? ' br-survey-scale-answer__choice--selected' : ''}`}
          aria-pressed={answer?.answer === value}
          aria-label={String(value)}
          tabIndex={tabIndex}
          onClick={() => onChange?.(value)}>{value}</button>)}
      </div>
      <div className="br-survey-scale-answer__labels">
        <span>{options.minLabel || options.minValue}</span>
        <span>{options.maxLabel || options.maxValue}</span>
      </div>
    </div>;
  }
}

export default LinearScaleAnswer;
